<template>
  <!--新增对话框-->
  <el-dialog
    :before-close="handleClose"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    append-to-body
    title="充值记录"
    width="80%"
  >
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="充值时间"
        min-width="160"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        align="center"
        label="充值金额"
        min-width="120"
        prop="amount"
      ></el-table-column>
      <el-table-column
        align="center"
        label="充值类型"
        min-width="120"
        prop="isAdmin"
      >
        <template slot-scope="{ row }">
          <span v-if="row.isAdmin == 1">系统充值</span>
          <span v-if="row.isAdmin == 0">用户充值</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="备注说明"
        min-width="120"
        prop="remark"
      ></el-table-column>
    </el-table>
    <div style="height: 50px">
      <el-pagination
        :current-page="current"
        :page-size="size"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "records",
  components: {},
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      userId: null,
      total: 0,
      size: 10,
      current: 1,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getUserList();
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetForm("editForm");
    },

    getUserList() {
      this.$axios
        .post("/admin/balanceRecord/getRechargeList", {
          pageNo: this.current,
          pageSize: this.size,
          userId: this.userId,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    init(id) {
      this.dialogVisible = true;
      this.userId = id;
      this.getUserList();
    },
  },
};
</script>

<style scoped></style>
